// Single source of truth for reading the Supabase session out of the
// supabase-js v2 storage key (`sb-{projectRef}-auth-token`).
//
// Why this exists:
// CRA previously kept a parallel `supabaseSession` localStorage entry that the
// SDK did not maintain. supabase-js auto-rotates its refresh_token every ~50
// minutes; the duplicate copy went stale within an hour and caused forced
// logouts (see bug investigation in PR for fix/cra-supabase-dual-storage).
// The SDK key is now the only source. On prod (Spring Boot backend) this key
// is absent — readers fall back to `userDetails.refresh_token`.

const deriveProjectRef = (url) => {
  if (!url) return null;
  try {
    return new URL(url).hostname.split(".")[0] || null;
  } catch {
    return null;
  }
};

export const getSupabaseStorageKey = (
  supabaseUrl = process.env.REACT_APP_SUPABASE_URL
) => {
  const ref = deriveProjectRef(supabaseUrl);
  return ref ? `sb-${ref}-auth-token` : null;
};

export const getSupabaseSession = (
  supabaseUrl = process.env.REACT_APP_SUPABASE_URL,
  storage = typeof localStorage !== "undefined" ? localStorage : null
) => {
  const key = getSupabaseStorageKey(supabaseUrl);
  if (!key || !storage) return null;
  const raw = storage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const getSupabaseRefreshToken = (
  supabaseUrl = process.env.REACT_APP_SUPABASE_URL,
  storage = typeof localStorage !== "undefined" ? localStorage : null
) => {
  const session = getSupabaseSession(supabaseUrl, storage);
  return session?.refresh_token || null;
};

export const getSupabaseAccessToken = (
  supabaseUrl = process.env.REACT_APP_SUPABASE_URL,
  storage = typeof localStorage !== "undefined" ? localStorage : null
) => {
  const session = getSupabaseSession(supabaseUrl, storage);
  return session?.access_token || null;
};
